import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import classNames from "classnames";
import React from "react";
import { FormattedMessage } from "react-intl";

interface DialogConfirmProps {
  onCancel: () => void;
  onConfirm: () => void;
  buttonClass?: string;
  titleClass?: string;
  open: boolean;
  title?: string | React.ReactNode;
  content?: string | React.ReactNode;
  cancelText?: string | React.ReactNode;
  okText?: string | React.ReactNode;
  testId?: string;
}

const useStyles = makeStyles(
  theme => ({
    root: {
      "& .MuiPaper-root": {
        maxWidth: 440,
        width: "100%",
        borderRadius: 16
      },
      "& .MuiDialogTitle-root": {
        padding: 24
      },
      "& .MuiDialogContent-root": {
        paddingTop: 5
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        paddingBottom: 24,
        columnGap: 16
      },
      "& .MuiButton-root": {
        fontSize: "1.8rem"
      }
    },
    title: {
      color: theme.palette.grey[900]
    },
    btnAction: {
      height: 48
    }
  }),
  { name: "DialogConfirmDelete" }
);

const DialogConfirm: React.FC<DialogConfirmProps> = ({
  onCancel,
  onConfirm,
  open,
  title,
  titleClass,
  content,
  cancelText,
  buttonClass,
  okText,
  testId
}) => {
  const classes = useStyles({});
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      className={classes.root}
      data-testid={testId ?? "dialogConfirm"}
    >
      {title ? (
        <DialogTitle>
          <MyTypography
            variant="h6"
            className={classNames(classes.title, titleClass)}
          >
            {title}
          </MyTypography>
        </DialogTitle>
      ) : (
        ""
      )}
      {content ? (
        <DialogContent>
          <MyTypography variant="body2">{content}</MyTypography>
        </DialogContent>
      ) : (
        ""
      )}
      <DialogActions disableSpacing={true}>
        <Button
          id="backButton"
          data-testid="backButton"
          color={"secondary"}
          variant={"outlined"}
          className={classNames(classes.btnAction, buttonClass)}
          fullWidth={true}
          onClick={onCancel}
        >
          {cancelText ? (
            cancelText
          ) : (
            <FormattedMessage defaultMessage={"กลับไป"} />
          )}
        </Button>
        <Button
          id="confirmButton"
          data-testid="confirmButton"
          color={"secondary"}
          variant={"contained"}
          className={classNames(classes.btnAction, buttonClass)}
          fullWidth={true}
          onClick={onConfirm}
        >
          {okText ? okText : <FormattedMessage defaultMessage={"ยืนยัน"} />}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogConfirm;
